import { useMemo } from 'react'
import { useRouter } from 'next/router'

/**
 * Hook to determine if the desktop sidebar should be hidden
 * Currently hides sidebar on extension welcome pages
 */
export const useHideDesktopSideNav = () => {
  const router = useRouter()

  return useMemo(() => {
    return router.pathname.startsWith('/extension/welcome')
  }, [router.pathname])
}
